<script>
import moment from 'moment';
import NotificationProgramSummary from '@components/notifications/notification-program-summary.vue';
import LastSession from './program-summary/last-session.vue';
import ThisWeekWorkout from './program-summary/this-week-workout.vue';
import PersonalData from './program-summary/personal-data.vue';

export default {
  components: {
    LastSession,
    ThisWeekWorkout,
    PersonalData,
    NotificationProgramSummary,
  },
  props: {
    client: {
      type: Object,
      required: true,
      default: () => {},
    },
    programWeeks: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  computed: {
    weekData() {
      return this.programWeeks.find((programWeek) =>
        moment(programWeek.weekOf).isSame(moment(), 'week')
      );
    },
    hasWorkOut() {
      let hasWorkOut = false;
      this.weekData.days.forEach((day) => {
        if (day.programDay_id) {
          day.workouts.forEach((workout) => {
            if (workout.hasWorkout) {
              hasWorkOut = true;
            }
          });
        }
      });
      return hasWorkOut;
    },
    currentWeekStartdate() {
      return moment()
        .startOf('week')
        .format('MMM D');
    },
  },
  created() {
    moment.updateLocale('en', {
      week: {
        dow: 1,
      },
    });
  },
};
</script>

<template>
  <div class="container program-summary-wrapper">
    <h1 class="mt-0">Fitness Program</h1>
    <div class="row mb-4">
      <div class="col-12" v-if="!hasWorkOut">
        <NotificationProgramSummary
          size="large"
          type="blue"
          content-position="center"
          :icon="true"
          :close="true"
        >
          <template v-slot:icon>
            <svg xmlns="http://www.w3.org/2000/svg" width="56" height="55.999" viewBox="0 0 56 55.999" v-bind:class="'icon'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path data-name="Subtraction 2" d="M48 56H8a8.007 8.007 0 01-8-8V8a8.009 8.009 0 018-8h40a8.008 8.008 0 018 8v40a8.007 8.007 0 01-8 8zM28 17.333a12.015 12.015 0 00-12 12 12.015 12.015 0 0012 12 12.013 12.013 0 0012-12 12.024 12.024 0 00-2.628-7.479l1.894-1.894a14.624 14.624 0 00-1.879-1.88l-1.893 1.894A11.88 11.88 0 0028 17.332zm-4-4V16h8v-2.667z" fill="#fff"/><path data-name="Rectangle 279" fill="#fff" d="M27 22h3v9h-3z"/></svg>
          </template>
          <div class="content mb-0"
            >Workout not scheduled for Week of {{ currentWeekStartdate }}.</div
          >
        </NotificationProgramSummary>
      </div>
    </div>
    <div class="row program-summary-row">
      <div class="col-12 col-xl-4 mb-5">
        <LastSession :client="client" />
      </div>
      <div class="col-12 col-xl-4 mb-5">
        <ThisWeekWorkout :client="client" :weekData="weekData" />
      </div>
      <div class="col-12 col-xl-4 mb-5">
        <PersonalData :client="client" />
      </div>
    </div>
  </div>
</template>

<style lang="scss">
@import '@design';
.program-summary-wrapper {
  margin-left: 0;
  margin-right: 0;
  padding-left: 32px;
  padding-right: 32px;
  .program-summary-row {
    .notification-wrapper {
      margin-top: auto;
      .notification {
        min-height: 97px;
      }
    }
  }
}
</style>
